import { InputHTMLAttributes, MutableRefObject, useState } from "react"
import * as Icons from "@nova/component-icons"
import classNames from "classnames"

type AuthenticationInputProps = {
    inputRef?: MutableRefObject<HTMLInputElement | null>
    name: string
    id: string
    label: string
    type: string
    onChange?: (e: { target: { value: string; name: string } }) => void
    defaultValue?: string
    disabled?: boolean
    leftIcon?: Icons.IconComponent
    rightIcon?: Icons.IconComponent
    rightIconClickHandler?: () => void
}

export const AuthenticationInput = ({
    inputRef,
    name,
    id,
    label,
    type,
    onChange,
    defaultValue,
    disabled,
    leftIcon,
    rightIcon,
    rightIconClickHandler,
    ...rest
}: AuthenticationInputProps & Omit<InputHTMLAttributes<HTMLInputElement>, "onChange">) => {
    const [focused, setFocused] = useState(false)
    return (
        <div onFocus={() => setFocused(true)}>
            <label htmlFor={name} className="authentication-management-label">
                {label}
            </label>
            <div className="relative mt-2">
                <input
                    ref={inputRef}
                    aria-invalid="false"
                    className={classNames("authentication-management-input", {
                        "!pl-12": !!leftIcon,
                        "!text-black-900": focused || disabled,
                    })}
                    type={type}
                    id={id}
                    data-tid={`authentication-email-${name}`}
                    name={name}
                    onChange={onChange}
                    defaultValue={defaultValue}
                    disabled={disabled}
                    {...rest}
                />
                {leftIcon && (
                    <div className="absolute left-[18px] top-[50%] -translate-y-[50%]">
                        <Icons.Icon
                            Icon={leftIcon}
                            className={classNames({ "text-black-900": focused || disabled })}
                        />
                    </div>
                )}
                {rightIcon && (
                    <div className="absolute right-[18px] top-[50%] -translate-y-[50%]">
                        <Icons.Icon
                            Icon={rightIcon}
                            onClick={rightIconClickHandler}
                            className={classNames(
                                { "text-black-900": focused },
                                { "cursor-pointer": !!rightIconClickHandler }
                            )}
                        />
                    </div>
                )}
            </div>
        </div>
    )
}
